import script from "./home-page.vue?vue&type=script&setup=true&lang=js"
export * from "./home-page.vue?vue&type=script&setup=true&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=5b7a10ae&lang=css"

const __exports__ = script;

export default __exports__